import Vue from "vue";
import App from "./App.vue";
import VueScrollTo from 'vue-scrollto';
import inViewportDirective from 'vue-in-viewport-directive'

Vue.config.productionTip = false;
Vue.directive('in-viewport', inViewportDirective)

Vue.use(VueScrollTo, {
  container: "body",
  duration: 900,
  easing: "ease-out",
  offset: -100,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

new Vue({
  render: h => h(App)
}).$mount("#app");